import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/services/common.service';
import { SnackbarService } from '../../snackbar/snackbar.service';

@Component({
  selector: 'app-comment-dialog',
  imports: [ReactiveFormsModule, TranslateModule],
  templateUrl: './comment-dialog.component.html',
  styleUrl: './comment-dialog.component.scss',
  standalone: true
})
export class CommentDialogComponent implements OnInit {
  commentForm: FormGroup;
  isSubmitDisabled

  constructor(private fb: FormBuilder,
    private dialogRef: MatDialogRef<CommentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private snackbarService: SnackbarService,
    private translate: TranslateService,
  ) {
    this.commentForm = this.fb.group({
      comment: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
  }

  onSubmitFeedback() {
    if (this.commentForm.valid) {
      const payload = {
        shiftId: this.data.shiftId,
        guardId: this.data.id,
        comment: this.commentForm.value.comment
      };
      this.commonService.rateAndCommentToGuard(payload).subscribe({
        next: () => {
          this.snackbarService.showSuccess(this.translate.instant('guard-shift-details.finish.guardFeedback.feedback-submitted-successfully'));
          this.commentForm.reset();
          this.dialogRef.close({
            success: true,
          });
        },
        error: () => {
          this.snackbarService.showSuccess(this.translate.instant('guard-shift-details.finish.guardFeedback.feedback-submitted-error'));
        }
      });
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}
